// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bhm_a bhm_j bhm_q bhm_sv bhm_sw bhm_w"};